import { DashboardListScreen } from 'screens/dashboard';

export default DashboardListScreen;
